export default "<div [innerHtml]=\"eventmarketingformhtml | safe:'html'\" registration-form-initializer [formHandler]=\"formHandler\">\n</div>"